import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-md-5 mb-lg-0" }
const _hoisted_2 = { class: "d-none d-lg-flex d-flex align-items-center text-dark fw-bolder fs-3 my-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-flex h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-flex overflow-auto h-55px" }, null, -1)
const _hoisted_5 = { class: "d-none d-md-flex me-auto" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1)
const _hoisted_9 = { class: "d-none d-md-flex py-1" }
const _hoisted_10 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.activeStart), 1),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Button, {
          onClick: _ctx.previous,
          type: "secondary",
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.next,
          type: "secondary",
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_Button, {
        onClick: _ctx.today,
        type: "",
        class: "btn-sm mx-2 btn-outline btn-outline-secondary text-white"
      }, {
        default: _withCtx(() => [
          _createTextVNode("today")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeView('resourceTimelineMonth'))),
          type: _ctx.currentViewType === 'resourceTimelineMonth' ? 'primary' : 'secondary',
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("month ")
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeView('resourceTimelineWeek'))),
          type: _ctx.currentViewType === 'resourceTimelineWeek' ? 'primary' : 'secondary',
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("week ")
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_Button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeView('resourceTimelineDay'))),
          type: _ctx.currentViewType === 'resourceTimelineDay' ? 'primary' : 'secondary',
          class: "btn-sm"
        }, {
          default: _withCtx(() => [
            _createTextVNode("day ")
          ]),
          _: 1
        }, 8, ["type"])
      ])
    ])
  ], 64))
}